import {getEventTitle} from '@wix/wix-events-commons-statics'
import {withTranslation} from '@wix/yoshi-flow-editor'
import {getEvent} from '../../selectors/event'
import {getGroupImage, getGroupTitle, getMembersCount, getUpdatesCount} from '../../selectors/groups'
import {DetailsPageAppProps} from '../app/interfaces'
import {connect} from '../runtime-context/context'
import {GroupCard as Presentation} from './group-card'
import {GroupCardOwnProps, GroupCardRuntimeProps} from './interfaces'

export const mapRuntime = ({state, actions: {joinGroup}}: DetailsPageAppProps): GroupCardRuntimeProps => ({
  eventTitle: getEventTitle(getEvent(state)),
  title: getGroupTitle(state),
  image: getGroupImage(state),
  membersCount: getMembersCount(state),
  updatesCount: getUpdatesCount(state),
  joinGroup,
})

export const GroupCard = withTranslation()(connect<GroupCardOwnProps, GroupCardRuntimeProps>(mapRuntime)(Presentation))
